/**
 * Completely prevents users from selecting out-of-stock product variants
 */
document.addEventListener('DOMContentLoaded', function() {
  // Function to handle disabled variant selection
  function preventOutOfStockSelection() {
    // Find all disabled variant inputs
    const disabledVariants = document.querySelectorAll('.product-form__input input[type="radio"].disabled');
    
    // For each disabled variant, find its label and completely disable interactions
    disabledVariants.forEach(input => {
      const variantId = input.id;
      const label = document.querySelector(`label[for="${variantId}"]`);
      
      if (label) {
        // Ensure the input can never be checked programmatically
        input.disabled = true;
        
        // Remove the for attribute to break the label-input connection
        const originalFor = label.getAttribute('for');
        label.removeAttribute('for');
        label.dataset.originalFor = originalFor; // Store original for reference
        
        // Capture and prevent all possible events
        const preventEvents = function(event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          // Show tooltip
          showOutOfStockTooltip(label);
          
          return false;
        };
        
        // Add multiple event listeners to ensure nothing gets through
        ['click', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'keydown', 'keyup'].forEach(eventType => {
          label.addEventListener(eventType, preventEvents, { capture: true });
        });
        
        // Add a special class for additional CSS targeting
        label.classList.add('completely-disabled');
      }
    });
    
    // Also intercept form submission if any disabled variant is selected
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    productForms.forEach(form => {
      form.addEventListener('submit', function(event) {
        const hasDisabledSelected = form.querySelector('input[type="radio"].disabled:checked');
        if (hasDisabledSelected) {
          event.preventDefault();
          event.stopPropagation();
          
          // Show message
          const label = document.querySelector(`label[data-original-for="${hasDisabledSelected.id}"]`) || 
                       document.querySelector(`label[for="${hasDisabledSelected.id}"]`);
          if (label) {
            showOutOfStockTooltip(label);
          }
          
          return false;
        }
      }, { capture: true });
    });
  }
  
  // Function to show out of stock tooltip
  function showOutOfStockTooltip(element) {
    const existingTooltip = document.getElementById('out-of-stock-tooltip');
    if (!existingTooltip) {
      const tooltip = document.createElement('div');
      tooltip.id = 'out-of-stock-tooltip';
      tooltip.textContent = 'This size is out of stock';
      tooltip.style.position = 'absolute';
      tooltip.style.backgroundColor = '#333';
      tooltip.style.color = '#fff';
      tooltip.style.padding = '5px 10px';
      tooltip.style.borderRadius = '4px';
      tooltip.style.fontSize = '12px';
      tooltip.style.zIndex = '1000';
      tooltip.style.pointerEvents = 'none';
      tooltip.style.opacity = '0';
      tooltip.style.transition = 'opacity 0.3s ease';
      
      // Position the tooltip near the element
      const rect = element.getBoundingClientRect();
      tooltip.style.top = `${rect.bottom + window.scrollY + 5}px`;
      tooltip.style.left = `${rect.left + window.scrollX}px`;
      
      document.body.appendChild(tooltip);
      
      // Show the tooltip
      setTimeout(() => {
        tooltip.style.opacity = '1';
      }, 10);
      
      // Hide and remove the tooltip after a delay
      setTimeout(() => {
        tooltip.style.opacity = '0';
        setTimeout(() => {
          if (tooltip.parentNode) {
            tooltip.parentNode.removeChild(tooltip);
          }
        }, 300);
      }, 2000);
    }
  }
  
  // Initial setup
  preventOutOfStockSelection();
  
  // Re-run when the page content might have changed
  document.addEventListener('shopify:section:load', preventOutOfStockSelection);
  
  // For dynamic content changes
  const observer = new MutationObserver(function(mutations) {
    let shouldReapply = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || 
          (mutation.target.classList && 
           (mutation.target.classList.contains('product-form__input') || 
            mutation.target.closest('.product-form__input')))) {
        shouldReapply = true;
      }
    });
    
    if (shouldReapply) {
      preventOutOfStockSelection();
    }
  });
  
  // Start observing the entire product form for changes
  const productForms = document.querySelectorAll('.product-form, form[action*="/cart/add"]');
  productForms.forEach(form => {
    observer.observe(form, { childList: true, subtree: true, attributes: true });
  });
  
  // Also observe variant selectors specifically
  const variantSelects = document.querySelectorAll('variant-selects, .product-form__input');
  variantSelects.forEach(select => {
    observer.observe(select, { childList: true, subtree: true, attributes: true });
  });
});
